import { create } from "zustand";

interface SchadenKIState {
  localApiKey: string;
  localApiUrl: string;
  originalApiKey: string;
  originalApiUrl: string;
  hasChanges: boolean;
  setLocalApiKey: (key: string) => void;
  setLocalApiUrl: (url: string) => void;
  setOriginalApiKey: (key: string) => void;
  setOriginalApiUrl: (url: string) => void;
  resetChanges: () => void;
}

const SchadenKIStore = create<SchadenKIState>((set, get) => ({
  localApiKey: "",
  localApiUrl: "",
  originalApiKey: "",
  originalApiUrl: "",
  hasChanges: false,

  setLocalApiKey: (key: string) => {
    const { originalApiKey, localApiUrl, originalApiUrl } = get();
    set({
      localApiKey: key,
      hasChanges: key !== originalApiKey || localApiUrl !== originalApiUrl,
    });
  },

  setLocalApiUrl: (url: string) => {
    const { originalApiUrl, localApiKey, originalApiKey } = get();
    set({
      localApiUrl: url,
      hasChanges: url !== originalApiUrl || localApiKey !== originalApiKey,
    });
  },

  setOriginalApiKey: (key: string) => {
    const { originalApiUrl, localApiUrl } = get();
    set({
      originalApiKey: key,
      localApiKey: key,
      hasChanges: localApiUrl !== originalApiUrl,
    });
  },

  setOriginalApiUrl: (url: string) => {
    const { originalApiKey, localApiKey } = get();
    set({
      originalApiUrl: url,
      localApiUrl: url,
      hasChanges: localApiKey !== originalApiKey,
    });
  },

  resetChanges: () => {
    const { originalApiKey, originalApiUrl } = get();
    set({
      localApiKey: originalApiKey,
      localApiUrl: originalApiUrl,
      hasChanges: false,
    });
  },
}));

export default SchadenKIStore;
